module.exports = __webpack_public_path__ + "img/noticias.3081f3d0.png";